const Google = 'Google';
const Facebook = 'Facebook';
const Twitter = 'Twitter';

export const externalLoginIdentifiers = { Google, Facebook, Twitter };

export const returnUrl = `${location.origin}/token`;
